import React, { useEffect, useState } from "react";
import { Reports } from "../../schedule/types/types";
import accessURL from "../../../../components/utils/access";
import UpdateModal from "./UpdateModal";
import { ReportData } from "./types";

// Interface for the complete API response
interface ApiResponse {
  status: string;
  data: {
    data: ReportData;
  };
}

interface Props {
  isOpen: boolean;
  onClose: () => void;
  report: Reports;
}

const UpdateReport: React.FC<Props> = ({ isOpen, onClose, report }) => {
  const [responseData, setResponseData] = useState<ReportData | null>(null);

  // Send the report to the backend
  const sendReportToBackend = async () => {
    try {
      const response = await accessURL.post<ApiResponse>(
        "/reports/send-report",
        report
      );
    
      setResponseData(response.data.data.data);
    } catch (error) {
      console.error("Error sending report to API:", error);
    }
  };

  // Trigger API call when modal is opened
  useEffect(() => {
    if (isOpen) {
      sendReportToBackend();
    }
  }, [isOpen, report]);

  if (!isOpen) return null;

  return <>{isOpen && <UpdateModal reportData={responseData} onClose={onClose} />}</>;
};

export default UpdateReport;
